<template>
  <div class="staff-contribution-item-input clearfix">
    <div class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <label :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
        <div class="input-group custom-dropdown">
          <select class="form-control" ref="dropdown"
          name="staff" @change="validateStaff($event.target)">
            <option value = "" disabled selected hidden>Select Staff</option>
            <option v-for="(val, index) in options.existing"
              :key="index"
              :value="val.value"
              :checked="val.value === value.eUuid"
              :selected="val.value === value.eUuid">{{ val.label ? val.label : val[options.objectName] }}</option>
          </select>
          <input class="form-control" type="text"
            id="contribution"
            :value="value.contribution"
            @input="validateContribution($event.target.value)"
            name="contribution"
            placeholder="Contribution"/>
          <span class="input-group-text">%</span>
          <input class="form-control" type="text"
            id="reportHours"
            :value="value.reportHours"
            @input="validateReportHours($event.target.value)"
            name="reportHours"
            placeholder="Report Hours"/>
          <input class="form-control" type="text"
            id="siteHours"
            :value="value.siteHours"
            @input="validateSiteHours($event.target.value)"
            name="siteHours"
            placeholder="Site Hours"/>
          <div class="input-group-append">
            <button class="btn btn-outline-danger" type="button" id="button-addon2" @click="options.removeItem(options.id)"><i class="fas fa-times" /></button>
          </div>
        </div>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  validationClass,
  validationMessage,
  validationIcon
} from '@/util/helpers'
import Choices from 'choices.js'
export default {
  name: 'StaffContributionItemInput',
  props: {
    value: {
      type: Object,
      default () {
        return {
          value: {
            contribution: '0',
            reportHours: 0,
            siteHours: 0,
            eUuid: ''
          }
        }
      }
    },
    options: {
      type: Object,
      default () {
        return {
          value: {
            contribution: 0,
            reportHours: 0,
            siteHours: 0,
            eUuid: ''
          }
        }
      }
    },
    onChange: {
      type: Function,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      regex: /^[0-9]*(\.{1}[0-9]{1,2})*$/,
      isValid: false,
      isDirty: false,
      invalidPercentage: false,
      moreThan100: false,
      invalidRepHour: false,
      invalidSiteHour: false
    }
  },
  computed: {
    validationClass,
    validationMessage,
    validationIcon,
    invalidMessage () {
      if (this.moreThan100) {
        return 'Amount cannot be more than 100%'
      } else if (this.invalidPercentage) {
        return 'The amount entered is not a valid % amount'
      } else if (this.invalidRepHour || this.invalidSiteHour) {
        return 'The number is invalid'
      } else if (!this.isValid) {
        return 'Fill all fields of Staff'
      } else {
        return 'Error'
      }
    }
  },
  methods: {
    validate () {
      let emptyValErr = false
      if (this.options.required) {
        for (var key in this.value) {
          let value = this.value[key]
          if (value === null || value === '') {
            emptyValErr = true
          }
        }
      }
      this.isValid = !(this.invalidPercentage || this.moreThan100 || this.invalidRepHour || this.invalidSiteHour || emptyValErr)
      this.options.itemState(this.isValid, this.options.id)
      if (this.isValid) {
        this.onChange()
      }
    },
    async validateStaff (event) {
      let val = event.value
      await this.$nextTick()
      let data = false
      if (!val) {
        data = this.choices.getValue()
        val = data ? data.value : null
      }
      this.value.eUuid = val
      this.$emit('input', this.value)
      this.isDirty = true
      this.validate()
    },
    validateContribution (val) {
      if (val === null) {
        val = '0'
      }
      this.value.contribution = val
      this.$emit('input', this.value)
      if (val) {
        this.isDirty = true
        this.invalidPercentage = !(new RegExp(this.regex, 'gi').test(val))
        this.moreThan100 = parseFloat(val) > 100
      }
      this.validate()
    },
    validateReportHours (val) {
      if (val === null) {
        val = '0'
      }
      this.value.reportHours = val
      this.$emit('input', this.value)
      if (val) {
        this.isDirty = true
        this.invalidRepHour = !(new RegExp(this.regex, 'gi').test(val))
      }
      this.validate()
    },
    validateSiteHours (val) {
      if (val === null) {
        val = '0'
      }
      this.value.siteHours = val
      this.$emit('input', this.value)
      if (val) {
        this.isDirty = true
        this.invalidSiteHour = !(new RegExp(this.regex, 'gi').test(val))
      }
      this.validate()
    }
  },
  mounted () {
    this.existingValues = this.options.existing || []
    let $vm = this
    /* eslint-disable no-new */
    this.choices = new Choices(this.$refs.dropdown, {
      placeholderValue: 'Enter a ' + this.options.label,
      noResultsText: 'No Results found',
      removeItemButton: false,
      fuseOptions: {
        threshold: 0.0,
        maxPatternLength: 256,
        matchAllTokens: true,
        tokenize: true
      },
      searchResultLimit: 500,
      searchFields: ['label'],
      callbackOnInit: function () {
        this.containerInner.id = $vm.options.name
        if (!$vm.value) {
          let arr = this.store.getItemsFilteredByActive()
          if (arr.length > 0) {
            let value = arr.pop().value
            this.removeItemsByValue(value)
          }
        } else {
          this.setValueByChoice($vm.value)
          $vm.validate()
        }
      }
    })
    document.removeEventListener('click', this.choices._onClick)
    document.removeEventListener('keyup', this.choices._onKeyUp)
    document.removeEventListener('keydown', this.choices._onKeyDown)
    document.addEventListener('click', (e) => {
      if (e.target.className.includes('choices') && e.target.tagName !== 'BUTTON') {
        this.choices._onClick(e)
      }
    }, true)
    document.addEventListener('keydown', (e) => {
      if (document.activeElement.className.includes('choices')) {
        if (e.keyCode === 13) {
          this.choices._onKeyDown(e)
          this.isSearching = false
        } else if (e.target.className.includes('choices')) {
          this.isSearching = true
          this.choices._onKeyDown(e)
        }
      } else {
        this.isSearching = false
      }
    }, true)
    document.addEventListener('keyup', (e) => {
      if (this.isSearching && document.activeElement.className.includes('choices')) {
        this.choices._onKeyUp(e)
      }
    }, true)
    // fix bug that causes dropdown to continually close until a key event is detected
    this.$refs.dropdown.addEventListener('showDropdown', (event) => {
      if (this.options.allowEdit) {
        let prefill = this.choices.getValue()
        this.choices.input.value = prefill ? prefill.label : ''
      } else {
        this.choices.clearInput()
      }
      this.$nextTick(function () {
        var e = new window.Event('keydown', {
          'bubbles': true
        })
        e.key = 'a'
        e.keyCode = e.key.charCodeAt(0)
        e.which = e.keyCode
        e.altKey = false
        e.ctrlKey = true
        e.shiftKey = false
        e.metaKey = false
        this.choices.input.dispatchEvent(e)
        this.choices.input.focus()
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/StaffContributionItemInput.vue